import React from 'react'
import { Box } from '@mui/material'
import type { TeamInformationSharesLineChartTooltipProps } from './types'
import { formatTooltipValue } from './helpers/teamInformationShares.helper'
import { useTranslation } from '../../../../../../shared/hooks/useIntractionTranslate'
import { INTERAX_COLORS } from '../../../../../../constants/colors'

/**
 * Custom tooltip component for Team Information Shares Line Chart
 */
export const TeamInformationSharesLineChartTooltip: React.FC<TeamInformationSharesLineChartTooltipProps> = ({
  active,
  payload,
  label
}) => {
  const { t } = useTranslation()

  if (!active || !payload || payload.length === 0) {
    return null
  }

  return (
    <Box
      sx={{
        padding: '12px',
        borderRadius: '8px',
        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.5)',
        backgroundColor: 'rgba(33, 38, 41, 0.8)',
        border: `1px solid ${INTERAX_COLORS.white10}`,
        backdropFilter: 'blur(6px)'
      }}
    >
      <Box
        component="p"
        className="text-body-2"
        sx={{
          fontWeight: 'bold',
          color: INTERAX_COLORS.white,
          marginBottom: '8px'
        }}
      >
        {t('facilitator.devTools.teamInformationShares.tooltip.period')}: {label}
      </Box>
      {payload.map((item, index) => (
        <Box
          key={`tooltip-item-${index}`}
          component="p"
          className="text-body-2"
          sx={{
            color: item.color,
            margin: 0
          }}
        >
          {`${item.name}: ${formatTooltipValue(item.value)} ${t('facilitator.devTools.teamInformationShares.tooltip.shares')}`}
        </Box>
      ))}
    </Box>
  )
}
